// extracted by mini-css-extract-plugin
export default {"inputGroup":"CompagyInformations_inputGroup__C5b1O"};